export default __webpack_public_path__ + "static/media/36I-102814_-16006_0.8f81df12.jpg";